import ContractAdjustmentDetail from 'components/features/adjustment-details';
import NewContractAdjustment from 'components/features/new-contract-adjustment';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

function ContractAdjustment() {
  const { t } = useTranslation();

  const { adjustmentId } = useParams<{
    contractId: string;
    adjustmentId?: string;
  }>();

  return (
    <HomeLayout title={t('contractAdjustment.contractAdjustment')}>
      {adjustmentId ? <ContractAdjustmentDetail /> : <NewContractAdjustment />}
    </HomeLayout>
  );
}

export default ContractAdjustment;
